import { AssignedEntityType, ExceptionFailureType } from '~/gql/graphql'

export const DISCOVERY_LABLES = [
    { id: 'customer', name: 'Customer' },
    { id: 'qc_hq', name: 'Quality - HQ' },
    { id: 'qc_feidi', name: 'Quality - Feidi' },
    { id: 'qc_india', name: 'Quality - India' },
    { id: 'mp', name: 'MP' },
    { id: 'mp_mfg_dri', name: 'MP Mfg DRI' },
    { id: 'auto', name: 'Auto' },
]

export const NOT_APPLICABLE = 'N/A'
export const ERROR_DURATION = 3

export const EXCEPTION_TYPES = [
    { label: 'OT', value: ExceptionFailureType.OT },
    { label: 'IF', value: ExceptionFailureType.IF },
    {
        label: 'RFI (request for information)',
        value: ExceptionFailureType.RFI,
    },
]

export const RESPONSIBILITY_OPTIONS = [
    { label: 'Fictiv', value: AssignedEntityType.FICTIV },
    { label: 'MP', value: AssignedEntityType.MP },
]

export const CUSTOMER_IMPACTED_OPTIONS = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const INVENTORY_MOVE_STATE = {
    PENDING: 'pending',
    SHIPPED: 'shipped',
    CANCEL: 'cancel',
}

export const ERP_SALE_ORDER_DELIVERY_STATE = {
    PENDING: 'pending',
    SHIPPED: 'shipped',
    CANCEL: 'cancel',
}

export const EXCEPTION_FORM_FIELDS = {
    TYPE: 'selectedType',
    FAILURE: 'isFailure',
    MILESTONE: 'milestoneType',
    JOB_REQUEST: 'selectedJobRequest',
    ASSIGNED_ENTITY: 'assignedEntity',
    ASSIGNEE: 'assignee',
    ACTION: 'action',
    CUSTOMER_AFFECTED: 'wasCustomerAffected',
    FAILURE_DESCRIPTION: 'additionalContext',
    DAYS_LATE: 'daysLate',
    DISCOVERED_BY: 'failureDiscoveredBy',
    RECEIPT_ID: 'receiptId',
    SHIPMENT_ID: 'shipmentId',
    NOTE: 'note',
    ALL_PARTS: 'allItems',
    SELECTED_PARTS: 'selectedLineItem',
    FICTIV_ASSIGNEE: 'fictivAssignee',
}

export const FORM_RULES = {
    [EXCEPTION_FORM_FIELDS.MILESTONE]: [
        { required: true, message: 'Please select milestone' },
    ],
    [EXCEPTION_FORM_FIELDS.JOB_REQUEST]: [
        { required: true, message: 'Please select job request' },
    ],
    [EXCEPTION_FORM_FIELDS.ASSIGNED_ENTITY]: [
        { required: true, message: 'Please select the responsible party' },
    ],
    [EXCEPTION_FORM_FIELDS.SELECTED_PARTS]: [
        {
            type: 'array',
            required: true,
            message: 'Please choose at least one job request line',
        },
    ],
    [EXCEPTION_FORM_FIELDS.ASSIGNEE]: [
        { required: true, message: 'Please select action assignee' },
    ],
    [EXCEPTION_FORM_FIELDS.ACTION]: [
        { required: true, message: 'Please select suggested action' },
    ],
    [EXCEPTION_FORM_FIELDS.CUSTOMER_AFFECTED]: [
        { required: true, message: 'Please choose if customr affected' },
    ],
    [EXCEPTION_FORM_FIELDS.TYPE]: [
        { required: true, message: 'Please select exception type' },
    ],
    [EXCEPTION_FORM_FIELDS.FAILURE_DESCRIPTION]: [
        { required: true, message: 'Please provide failure description' },
    ],
    [EXCEPTION_FORM_FIELDS.DAYS_LATE]: [
        { required: true, message: 'Please provide number days late value' },
    ],
    [EXCEPTION_FORM_FIELDS.DISCOVERED_BY]: [
        { required: true, message: 'Please select discovered by' },
    ],
    [EXCEPTION_FORM_FIELDS.FICTIV_ASSIGNEE]: [
        { required: true, message: 'Please select fictiv assignee' },
    ],
}

export const ASSIGNEE_FILTERS_FOR_FAILURES = [
    { LABEL: 'MP', VALUE: 'mp' },
    { LABEL: 'Logistics', VALUE: 'logistics' },
    { LABEL: 'Customer Mfg Dri', VALUE: 'customer_mfg_dri' },
    { LABEL: 'Manufacturer Mfg DRI', VALUE: 'manufacture_mfg_dri' },
    { LABEL: 'QC', VALUE: 'quality' },
    { LABEL: 'Logistics/Shipping', VALUE: 'logistics_shipping' },
    { LABEL: 'SQE', VALUE: 'sqe' },
] as const
